import styled, {css} from "styled-components";
import {DetailModal} from "../detail/TicketDetail.styles";

export const CreateModal = styled(DetailModal)`
    .ant-modal-header {
        padding: 16px 24px;
    }

    .ant-modal-footer {
        border-top: none;
        padding: 0 24px 20px;

        .ant-btn {
            height: 36px;
            border-radius: 8px;
        }

        ${({$customer}) =>
            $customer &&
            css`
                .ant-btn-primary {
                    background-color: #aef001;
                    border-color: #aef001;
                    color: #000;
                    font-weight: 500;
                }

                .ant-btn-primary:hover:not(:disabled),
                .ant-btn-primary:focus:not(:disabled) {
                    background-color: #9dd600;
                    border-color: #9dd600;
                    color: #000;
                }
            `}
    }

    .ant-form-item-label > label {
        height: auto;
        font-weight: 600;
    }

    .ant-input,
    .ant-select:not(.ant-select-customize-input) .ant-select-selector {
        border-radius: 8px;
    }

    .ant-upload-select-picture-card,
    .ant-upload-list-picture-card .ant-upload-list-item {
        border: 1px solid #d6e4ff;
        border-radius: 8px;
        background: #f0f7ff;
    }
`;

export const OwnerNotice = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
    padding: 10px 16px;
    border: 1px solid #d6e4ff;
    border-radius: 8px;
    background: #f0f7ff;
    font-weight: 500;
`;

export const VisibilityBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 12px 16px;
    border: 1px solid #d6e4ff;
    border-radius: 8px;
    background: #f5f9ff;
`;

export const LabelText = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
`;
